import React from "react";
import styled from "styled-components";
import { viewSizeCalculator } from "../../../utils";
import { SquareSkeleton, TextSkeleton } from "../index.styled";

const ListViewSkeleton = () => {
  return (
    <ListViewContainer>
      <SquareSkeleton />
      <TextContainer>
        <TextSkeleton />
        <TextSkeleton height={1.1} borderRadius={0.35} />
      </TextContainer>
    </ListViewContainer>
  );
};

export default ListViewSkeleton;

const ListViewContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  gap: ${viewSizeCalculator(0.7)};
`;

const TextContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${viewSizeCalculator(0.2)};
`;
